/* eslint-disable import/no-import-module-exports */
import { composeWithDevTools } from '@redux-devtools/extension';
import { applyMiddleware, createStore, PreloadedState } from 'redux';
import thunk from 'redux-thunk';

import packageInfo from '../../package.json';
import rootReducer from '../reducers';
// eslint-disable-next-line import/no-relative-packages
import createLogger from './logger/logger.server';

export default function configureStore(
  initialState: PreloadedState<typeof rootReducer>,
) {
  const middleware = [thunk.withExtraArgument({})];

  let enhancer;

  if (__DEV__) {
    middleware.push(createLogger());

    // https://github.com/zalmoxisus/redux-devtools-extension#14-using-in-production
    const composeEnhancers = composeWithDevTools({
      // Options: https://github.com/zalmoxisus/redux-devtools-extension/blob/master/docs/API/Arguments.md#options
      name: `${packageInfo.name}@${packageInfo.version}`,
    });

    // https://redux.js.org/docs/api/applyMiddleware.html
    enhancer = composeEnhancers(applyMiddleware(...middleware));
  } else {
    enhancer = applyMiddleware(...middleware);
  }

  // https://redux.js.org/docs/api/createStore.html
  const store = createStore(rootReducer, initialState, enhancer);

  // Hot reload reducers (requires Webpack or Browserify HMR to be enabled)
  if (__DEV__ && module.hot) {
    module.hot.accept('../reducers', () =>
      // eslint-disable-next-line @typescript-eslint/no-var-requires
      store.replaceReducer(require('../reducers').default),
    );
  }

  return store;
}
